import { ReviewSubmissionModel } from "@/types/service/reviews/reviewSubmission.model";

import { WriteReviewComponent } from "./writeReview.component";

export type WriteReviewContainerProps = {
    initialRating: number | null;
    reviewSubmission: ReviewSubmissionModel | null;
    reviewAuthor: string | null;
    fieldErrors: Partial<Record<keyof ReviewSubmissionModel, string>>;
    onSubmit: (value: ReviewSubmissionModel) => Promise<void>;
};

const WriteReviewContainer = ({
    initialRating,
    reviewSubmission,
    reviewAuthor,
    fieldErrors,
    onSubmit
}: WriteReviewContainerProps) => {
    return (
        <WriteReviewComponent
            initialRating={initialRating}
            reviewSubmission={reviewSubmission}
            reviewAuthor={reviewAuthor}
            fieldErrors={fieldErrors}
            onSubmit={onSubmit}
        />
    );
};

export { WriteReviewContainer };
